import React from 'react';
import { useNavigate } from 'react-router-dom';
import { soundManager } from '../utils/SoundManager';
import knightsThreeTrainersData from '../data/KnightsThree';
import './KnightsThree.css';

const KnightsThreeTrainers = () => {
    const navigate = useNavigate();

    // Convert trainer data object to array
    const trainers = Object.values(knightsThreeTrainersData);

    // Handle trainer selection
    const handleTrainerSelect = (trainer) => {
        console.log('⚔️ Knights Three trainer selected:', trainer.name);

        // 🎵 TRAINER SELECTION SOUND
        soundManager.playButtonSound();

        // Navigate to individual trainer page
        navigate(`/knight-trainer/${trainer.id}`);
    };

    // Handle back navigation
    const handleBackToCategories = () => {
        soundManager.playButtonSound();
        navigate('/knights-train-categories');
    };

    return (
        <div className="knights-three-trainers-container">
            <div className="knights-three-animated-background"></div>

            {/* Back Button */}
            <button
                className="back-to-categories-button knights-three-back"
                onClick={handleBackToCategories}
            >
                ← Back to Categories
            </button>

            {/* Header */}
            <div className="knights-three-trainers-header">
                <div className="header-content">
                    <h1>Specialized & Unique Knights</h1>
                    <p>Train with the most distinctive warriors of the realm</p>
                    <div className="category-stats">
                        <span className="stat-badge knights-three-badge">Trainers: {trainers.length}</span>
                        <span className="stat-badge knights-three-badge">Programs: {trainers.length * 6}</span>
                        <span className="stat-badge knights-three-badge">Category: Unique Knights</span>
                    </div>
                </div>
            </div>

            {/* Trainers Grid */}
            <div className="knights-three-trainers-grid">
                {trainers.map((trainer, index) => (
                    <div
                        key={trainer.id}
                        className="knight-three-trainer-card"
                        onClick={() => handleTrainerSelect(trainer)}
                        style={{
                            '--knight-three-primary-color': trainer.color,
                            '--knight-three-secondary-color': trainer.secondaryColor
                        }}
                    >
                        {/* Trainer Image */}
                        <div className="knight-three-trainer-image-section">
                            <div
                                className="knight-three-trainer-image"
                                style={{
                                    backgroundImage: `url(${trainer.image})`
                                }}
                            >
                                <div className="prismatic-gleam-effect"></div>
                                <div className="experience-badge knight-three-badge">
                                    {trainer.experience}
                                </div>
                            </div>
                        </div>

                        {/* Trainer Info */}
                        <div className="knight-three-trainer-info-section">
                            <h3 className="knight-three-trainer-name">{trainer.name}</h3>
                            <h4 className="knight-three-trainer-title">{trainer.title}</h4>
                            <p className="knight-three-trainer-specialization">{trainer.specialization}</p>
                            <p className="knight-three-trainer-description">{trainer.intro}</p>

                            <div className="knight-three-trainer-details">
                                <div className="detail-item knight-three-detail">
                                    <div className="detail-icon">🏹</div>
                                    <div className="detail-text">Programs: {trainer.programs.length}</div>
                                </div>
                                <div className="detail-item knight-three-detail">
                                    <div className="detail-icon">🎯</div>
                                    <div className="detail-text">{trainer.experience}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Footer */}
            <div className="knights-three-trainers-footer">
                <div className="knights-three-info">
                    <h3>Specialized Knights Philosophy</h3>
                    <div className="knights-three-benefits-grid">
                        <div className="knight-three-benefit-item">
                            <div className="benefit-icon">👑</div>
                            <div>
                                <strong>Administrative Excellence</strong>
                                <p>Leadership conditioning that manages kingdoms through superior organization</p>
                            </div>
                        </div>
                        <div className="knight-three-benefit-item">
                            <div className="benefit-icon">🌟</div>
                            <div>
                                <strong>Chivalric Idealism</strong>
                                <p>Noble training that maintains perfect principles in an imperfect world</p>
                            </div>
                        </div>
                        <div className="knight-three-benefit-item">
                            <div className="benefit-icon">🐺</div>
                            <div>
                                <strong>Primal Transformation</strong>
                                <p>Wild conditioning that embraces dual nature and instinctual power</p>
                            </div>
                        </div>
                        <div className="knight-three-benefit-item">
                            <div className="benefit-icon">🎭</div>
                            <div>
                                <strong>Joyful Resilience</strong>
                                <p>Humor-based training that proves laughter is a source of true strength</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KnightsThreeTrainers;